module.exports = __webpack_public_path__ + "img/delet.687725f1.svg";